"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    AlphaSlider: function() {
        return _index.AlphaSlider;
    },
    alphaSliderCSSVars: function() {
        return _index.alphaSliderCSSVars;
    },
    alphaSliderClassNames: function() {
        return _index.alphaSliderClassNames;
    },
    renderAlphaSlider_unstable: function() {
        return _index.renderAlphaSlider_unstable;
    },
    useAlphaSliderStyles_unstable: function() {
        return _index.useAlphaSliderStyles_unstable;
    },
    useAlphaSlider_unstable: function() {
        return _index.useAlphaSlider_unstable;
    }
});
const _index = require("./components/AlphaSlider/index");
